var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"img-focal-point-picker-container"},[_c('div',{staticClass:"constraint-frame"},[_c('img',{attrs:{"src":_vm.fileUrl},on:{"load":_vm.onImgLoaded}}),_vm._v(" "),_c('span',{staticClass:"focal-point-cursor"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }